import React, { useContext, useState, useRef } from 'react';
import { Container, Row, Col, Table, Spinner, Form, InputGroup, Button } from 'react-bootstrap';
import $ from 'jquery';
import ReactToPrint from "react-to-print";
import generatePDF from 'react-to-pdf';
import { AppContext } from '../App';


export const DayCloseReopenReport = () => {
	const { getCreditReport, reOpenRepo, setReOpenRepo, getDate, postCall, load, setLoad, downloadExcel } = useContext(AppContext);
	const [filename, setFilename] = useState('report_day_close_reopen.xlsx');
	const tableRef = useRef(null);

	const getReport = (e) => {
		e.preventDefault();
		let start = e.target.start.value;
		let end = e.target.end.value;
		let staff = e.target.staff.value;
		if (start !== "" && end !== "") {
			setLoad(true);
			postCall('api/bnr/get/verify/reopen/report/', { start_date: start, end_date: end, staff_id: staff }).then(res => {
				setReOpenRepo(res.data);
				setFilename(`report_day_close_reopen_${start}_${end}.xlsx`);
				setLoad(false);
			}).catch(err => {
				setLoad(false);
			});
		}
	}

	const formatExcel = () => {
		if (reOpenRepo !== undefined && reOpenRepo.reopen_values !== undefined && Object.keys(reOpenRepo.reopen_values).length > 0) {
			let data = [];
			Object.keys(reOpenRepo.reopen_values).map(reop => {
				data.push({
					'Date': reOpenRepo.reopen_values[reop].reopen_date,
					'Staff': reOpenRepo.reopen_values[reop].user,
					'Re opened by': reOpenRepo.reopen_values[reop].reopened_by,
					'Remarks': reOpenRepo.reopen_values[reop].remarks,
				});
			});
			return data;
		}
	}

	return (
		<div className='container-fluid'>
			<div className='grid4by6 align-items-center p-2 bgp br-3' >
				{
					load ? (
						<div className="d-grid">
							<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>
						</div>
					) : (
						<span>Day close re open report</span>
					)
				}
				<Form onSubmit={getReport} >
					<Row>
						<Col xs={12} sm={4} md={3} >
							<InputGroup className="br-3">
								<InputGroup.Text className="br-3" id="inputGroup-sizing-default">From</InputGroup.Text>
								<Form.Control name="start" type="date" defaultValue={getDate()} className="br-3" />
							</InputGroup>
						</Col>
						<Col xs={12} sm={4} md={3} >
							<InputGroup className="br-3">
								<InputGroup.Text className="br-3" id="inputGroup-sizing-default">To</InputGroup.Text>
								<Form.Control name="end" type="date" defaultValue={getDate()} className="br-3" />
							</InputGroup>
						</Col>
						<Col xs={12} sm={4} md={3} >
							<Form.Select name="staff" className="shadow-none br-2">
								<option value="" >All staffs</option>
								{
									reOpenRepo !== undefined ? (
										reOpenRepo.users !== undefined ? (
											Object.keys(reOpenRepo.users).length > 0 ? (
												Object.keys(reOpenRepo.users).map((staff, staff_i) => (
													<option value={staff.substring(1)} key={`user_${staff_i}`} >{reOpenRepo.users[staff].username}</option>
												))
											) : ''
										) : ''
									) : ''
								}
							</Form.Select>
						</Col>
						<Col xs={12} sm={4} md={3} className="d-grid" >
							<Button type="submit" className="btn-t1-r br-3" >Get Report</Button>
						</Col>
					</Row>
				</Form>
			</div>
			{
				reOpenRepo !== undefined && reOpenRepo.reopen_values !== undefined && Object.keys(reOpenRepo.reopen_values).length > 0 ? (
					<div className='d-flex justify-content-end align-items-center mb-2 gap-2' >
						<span>Download</span>
						<Button className="br-1" onClick={() => {
							downloadExcel(formatExcel(), filename);
						}} size='sm' variant='success' ><i className='bi bi-download' ></i> Excel</Button>
						<Button onClick={() => {
							generatePDF(tableRef, filename);
						}} size='sm' className='br-1' variant='success' ><i className='bi bi-download' ></i> Pdf</Button>
						<ReactToPrint
							trigger={() => <Button className='br-1' variant='success' size='sm'><i className="bi bi-printer"></i> Print</Button>}
							content={() => tableRef.current}
						/>
					</div>
				) : null
			}
			<div ref={tableRef}>
				{

					reOpenRepo !== undefined && reOpenRepo.reopen_values !== undefined && Object.keys(reOpenRepo.reopen_values).length > 0 ? (
						<Table bordered className="tbl-bg-blue" >
							<thead>
								<tr>
									<th className="tp2" >Date</th>
									<th className="tp2" >Staff</th>
									<th className="tp2" >Re opened by</th>
									<th className="tp2" >Remarks</th>
								</tr>
							</thead>
							<tbody>
								{
									Object.keys(reOpenRepo.reopen_values).map((reop, reopi) => (
										<tr key={`reop_${reopi}`} className="tp2"  >
											<td>{reOpenRepo.reopen_values[reop].reopen_date}</td>
											<td>{reOpenRepo.reopen_values[reop].user}</td>
											<td>{reOpenRepo.reopen_values[reop].reopened_by}</td>
											<td>{reOpenRepo.reopen_values[reop].remarks}</td>
										</tr>
									))
								}
							</tbody>
						</Table>
					) : ''
				}
			</div>

		</div>
	)
}